<template>
  <div class="timeline is-centered" v-if="items.length">
    <header class="timeline-header">
      <span class="tag is-medium is-primary">Recente</span>
    </header>
    <div class="timeline-item is-primary" v-for="(item, index) in items" :key="index">
      <div class="timeline-marker is-primary is-icon"></div>
      <div class="timeline-content">
        <p class="heading">{{item.date}}</p>
        <router-link :to="'/' + item.kind + '/' + item.id"><p class="has-text-weight-bold">{{item.type}}</p></router-link>
        <p class="has-text-grey is-abbr-like">{{item.subtype}}</p>
        <p v-if="item.status || item.special" :class="'has-text-weight-bold ' + getStatus(item)">
          {{item.status}}
          <span v-if="item.special" class="has-text-weight-normal"><font-awesome-icon icon="circle" class="status-special-color ml-1" /></span>
          <span v-if="item.special2" class="has-text-weight-normal"><font-awesome-icon icon="circle" class="status-special-color-2 ml-1" /></span>
        </p>
      </div>
    </div>
    <header class="timeline-header">
      <span class="tag is-medium is-primary">Vecchio</span>
    </header>
  </div>
  <div v-else-if="waiting">
    <div class="has-text-centered has-text-grey">Caricamento...</div>
  </div>
  <div v-else>
    <div class="has-text-centered has-text-grey">Vuoto</div>
  </div>
</template>

<script>
export default {
  props: ['entity', 'id'],
  
  data() {
    return {
      items: [],
      waiting: true
    }
  },

  methods: {
    getAll() {
      const self = this

      self.waiting = true

      this.$http.get('/' + self.entity + '/' + self.id + '/history')
        .then(function (response) {
          response.data.forEach(record => {
            const date = new Date(record.date)

            self.items.push({
              id: record._id,
              kind: record.kind,
              date: date.getDate() + ' ' + date.toLocaleString('default', { month: 'long' }) + ' ' + date.getFullYear(),
              type: record.type,
              subtype: record.subtype,
              status: record.status,
              special: record.special,
              special2: record.special2
            })
          })

          self.waiting = false
        })
        .catch(function (error) {
          console.log(error)
          alert('Errore')
          self.waiting = false
        })
    },

    getStatus(operation) {
      let result = ''

      if (operation.status === 'Concluso') {
        result = 'status-closed-color'
      } else if (operation.status === 'Annullato') {
        result = 'status-cancel-color'
      } else if (operation.status === 'Da completare') {
        result = 'status-waiting-color'
      }

      return result
    },
  },

  mounted() {
    this.getAll()
  }
}
</script>

<style lang="scss">
@import "../variables.scss";

.status-closed-color {
  color: $status-closed;
}
.status-cancel-color {
  color: $status-cancel;
}
.status-waiting-color {
  color: $status-waiting-dark;
}
.status-special-color {
  color: $status-special;
}
.status-special-color-2 {
  color: $status-special-2;
}
</style>